import { Modal } from '@/components/base/Modal'
import { PopUp } from '@/components/base/PopUp'
import { Text3 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import useIsMobile from '@/hooks/useMobile'
import { align } from '@/styles/display'
import { whiteSpace } from '@/styles/white_space'

interface Props {
  companyName: string
  isShowModal: boolean
  isCancelModal: boolean
  onClickDoneButton: () => void
  onCloseModal: () => void
}

export const OfferAcceptanceModal = ({
  companyName,
  isShowModal,
  isCancelModal,
  onClickDoneButton,
  onCloseModal
}: Props): JSX.Element => {
  const app = useApp()
  const isMobile = useIsMobile()

  return (
    <Modal isOpen={isShowModal}>
      <PopUp
        activeButton={{
          name: `内定を承諾する`,
          bgColor: app.theme.primaryMainColor,
          textColor: app.theme.whiteColor,
          onClickButton: onClickDoneButton
        }}
        inactiveButton={{
          name: 'もどる',
          bgColor: app.theme.whiteColor,
          textColor: app.theme.subTextColor,
          onClickButton: onCloseModal
        }}
        onClickClose={onCloseModal}
      >
        <Text3
          lineHeight="175%"
          whiteSpace={whiteSpace.PRE_LINE}
          textAlign={isMobile ? align.LEFT : align.CENTER}
        >
          {`承諾先の企業名：${companyName}
上記企業へ内定の承諾意思を伝えます。
お間違いなければ、「内定を承諾する」ボタンを押してください。`}
        </Text3>
      </PopUp>
    </Modal>
  )
}
